import { render, staticRenderFns } from "./VlInternalDocuments.vue?vue&type=template&id=61b154a0&scoped=true&"
import script from "./VlInternalDocuments.vue?vue&type=script&lang=js&"
export * from "./VlInternalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b154a0",
  null
  
)

export default component.exports